import { AppStoreBadges } from './AppStoreBadges';

export const PricingPreviewSection = () => (
  <section className="py-20 sm:py-28" data-testid="pricing-preview-section">
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
      <span className="text-xs uppercase tracking-[0.2em] font-sans font-semibold text-primary">Pricing</span>
      <h2 className="mt-3 text-2xl sm:text-3xl lg:text-4xl tracking-tight font-serif font-bold">
        Starting at just <span className="text-primary">£6.99/month</span>
      </h2>
      <p className="mt-4 text-muted-foreground text-base max-w-lg mx-auto leading-relaxed">
        Unlimited disputes, AI verdicts, relationship counsellor access, and more. Cancel anytime.
      </p>
      <div className="mt-8 flex justify-center">
        <AppStoreBadges idSuffix="pricing-preview" />
      </div>
    </div>
  </section>
);
